"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.action('setIsSearching')(function setIsSearching(viewstate, isSearching) {
    viewstate.isSearching = isSearching;
});
//# sourceMappingURL=setIsSearching.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-readwrite-recipient-well/lib/actions/setIsSearching.js
// module id = 2689
// module chunks = 2 3 4 45